import { format } from "date-fns";
import { parseDateForBackend } from "./parseDateForBackend";

// Function to parse phone number and extract country code and local number
const parsePhoneNumber = (phoneNumber) => {
  const match = phoneNumber.match(/^\+(\d{1,3})(\d{10,})$/);
  if (match) {
    return {
      countryCode: match[1],
      localNumber: match[2],
    };
  }
  return {
    countryCode: "",
    localNumber: "",
  };
};
export default parsePhoneNumber;

//Allow only positive value
export const handleKeyDownforPositiveNumber = (event) => {
  // Allow numeric, control keys, and Ctrl+C, Ctrl+V, Ctrl+A
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
  ];
  if (
    !(
      event.key.match(/[0-9]/) || // Allow numeric keys
      (event.ctrlKey && ["c", "v", "a"].includes(event.key.toLowerCase())) || // Allow Ctrl+C, Ctrl+V, Ctrl+A
      allowedKeys.includes(event.key)
    ) // Allow other control keys
  ) {
    event.preventDefault();
  }
};

//css for dropdown accoding to theam
export const customStylesDropdown = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "var(--primary_orange)" : "",

    color: state.isSelected ? "white" : "var(--primary_orange)",
    marginBottom: "4px",
    "&:hover": {
      background: "#DEEBFF",
    },
  }),
};

// Function to map dropdown options from different arrays
// If not specified, default labelKey is "option" and valueKey is "id"
// if array of strings is passed as labelKey argument, array items will be concatenated (first + last name example)
export const mapDropdownOptions = (
  options,
  labelKey = "option",
  valueKey = "id",
  withDefaultOption = false,
  t
) => {
  if (!options || !Array.isArray(options)) return [];

  const dropdownOptions = options.map((item) => ({
    label: Array.isArray(labelKey)
      ? labelKey
          .map((key) => item[key])
          .filter(Boolean)
          .join(" ")
      : item[labelKey],
    value: item[valueKey],
  }));

  if (withDefaultOption) {
    dropdownOptions.unshift({ label: t('misc.all'), value: "" });
  }

  return dropdownOptions;
};

// get dropdown option's label
export const getOption = (options, value, t) =>
  options?.find((option) => option?.value === value)?.label || t('misc.all');

// get dropdown option
export const getSelectedOption = (options, value) => {
  return value ? options.find((opt) => opt.value === value) : null;
};

// format date
export const slashToHyphenDate = (slashDate) => {
  if (!slashDate) return "";
  const slashDateParts = slashDate.split("/");

  return `${slashDateParts[2]}-${slashDateParts[1]}-${slashDateParts[0]}`;
};

// format date
export const hyphenToSlashDate = (hyphenDate) => {
  if (!hyphenDate) return "";
  const hyphenDateParts = hyphenDate.split("-");

  return `${hyphenDateParts[2]}/${hyphenDateParts[1]}/${hyphenDateParts[0]}`;
};

// format date
export const slashToDate = (hyphenDate) => {
  if (!hyphenDate) return "";
  const hyphenDateParts = hyphenDate.split("/");
  const date = new Date();

  date.setYear(hyphenDateParts[2]);
  date.setMonth(hyphenDateParts[1] - 1);
  date.setDate(hyphenDateParts[0]);

  return date;
};

export const getAdjustedDate = (baseDate, offsetDays) => {
  const date = new Date(baseDate);
  date.setDate(baseDate.getDate() + offsetDays);
  return date;
};

// Helper function to calculate new date range filters with separate offsets for start and end dates
export const setDateRange = (startDate, startOffset, endDate, endOffset) => ({
  start_date: parseDateForBackend(getAdjustedDate(startDate, startOffset)),
  end_date: parseDateForBackend(getAdjustedDate(endDate, endOffset)),
});

// Helper functions to get first and last day of a month
export const getFirstDayOfMonth = (date) =>
  new Date(date.getFullYear(), date.getMonth(), 1);
export const getLastDayOfMonth = (date) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0);
